import { checkSession } from '../../components/Router';
import login from './login';

export default checkSession(login, true, true);
export { getStaticPaths, getStaticProps } from '../../utils/DynamicRoutes';
